const initialState = {
  sendCodeResult: {},
  verifyCodeResult: {},
};

// 发送验证码参数
export default function sendCode(state = initialState, action) {
  switch (action.type) {
  case 'SEND_CODE':
    return { ...state, sendCodeResult: action.payload };
  case 'VERIFY_CODE':
    return { ...state, verifyCodeResult: action.payload };
  default:
    return state;
  }
}